import { api } from '@/services'
export function fetchQuestionnaires(params) {
  return api.get('/admin/questionnaire/list', { params: params })
}
export function fetchQuestionnaire(id) {
  return api.get(`/admin/questionnaire/show/${id}`)
}
export function createQuestionnaire(params) {
  return api.post('/admin/questionnaire/create', params)
}
export function updateQuestionnaire(params) {
  return api.post(`/admin/questionnaire/updateQuestionnaire/${params.id}`, params)
}
export function publish(id) {
  return api.post(`/admin/questionnaire/publish/${id}`)
}
export function getDownloadFileAnswerUrl(answerId, isAdmin) {
    return api.get(`/${isAdmin ? 'admin' : 'web'}/questionnaire/fileDownloadURL?answerId=${answerId}`)
}
